import apiNews from '@/api/news'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  news: null,
}

export const mutationTypes = {
  updateNewsStart: '[update news] Update news start',
  updateNewsSuccess: '[update news] Update news success',
  updateNewsFailure: '[update news] Update news failure',

  getNewsStart: '[update news] Get news start',
  getNewsSuccess: '[update news] Get news success',
  getNewsFailure: '[update news] Get news failure',
}

export const actionTypes = {
  updateNews: '[update news] Update news',
  getNews: '[update news] Get news',
}

const mutations = {
  [mutationTypes.updateNewsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateNewsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateNewsFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getNewsStart](state) {
    state.isLoading = true
    state.news = null
  },

  [mutationTypes.getNewsSuccess](state, payload) {
    state.news = payload
    state.isLoading = false
  },

  [mutationTypes.getNewsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.updateNews](context, {id, newsInput}) {
    context.commit(mutationTypes.updateNewsStart)
    return new Promise((resolve) => {
      apiNews
        .updateNews(id, newsInput)
        .then((response) => {
          context.commit(mutationTypes.updateNewsSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.updateNewsFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getNews](context, {id}) {
    context.commit(mutationTypes.getNewsStart)
    return new Promise((resolve) => {
      apiNews
        .getNews(id)
        .then((response) => {
          context.commit(mutationTypes.getNewsSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getNewsFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
